/*eslint-disable*/
import axios from 'axios';
import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useSelector } from 'react-redux';
import styled from 'styled-components';

const Container = styled.div`
  min-height: 100vh;
  background: #f5f7fa;
  padding: 30px;

  @media (max-width: 768px) {
    padding: 15px;
  }
`;

const Header = styled.div`
  background: white;
  border-radius: 12px;
  padding: 30px;
  margin-bottom: 30px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
  display: flex;
  justify-content: space-between;
  align-items: center;
  flex-wrap: wrap;
  gap: 20px;

  @media (max-width: 768px) {
    flex-direction: column;
    align-items: flex-start;
  }

  h1 {
    color: #333;
    font-size: 32px;
    font-weight: 600;
    margin: 0;
  }
`;

const Actions = styled.div`
  display: flex;
  gap: 12px;
  align-items: center;

  @media (max-width: 768px) {
    width: 100%;
    flex-direction: column;
  }
`;

const SearchInput = styled.input`
  padding: 10px 16px;
  border: 2px solid #e0e0e0;
  border-radius: 8px;
  font-size: 14px;
  width: 300px;
  transition: border-color 0.3s;

  &:focus {
    outline: none;
    border-color: #667eea;
  }

  @media (max-width: 768px) {
    width: 100%;
  }
`;

const RefreshButton = styled.button`
  padding: 10px 20px;
  background: #667eea;
  color: white;
  border: none;
  border-radius: 8px;
  font-size: 14px;
  font-weight: 500;
  cursor: pointer;
  transition: background 0.3s;

  &:hover:not(:disabled) {
    background: #5568d3;
  }

  &:disabled {
    background: #ccc;
    cursor: not-allowed;
  }
`;

const Content = styled.div`
  background: white;
  border-radius: 12px;
  padding: 30px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
`;

const TableContainer = styled.div`
  overflow-x: auto;
`;

const Table = styled.table`
  width: 100%;
  border-collapse: collapse;
  margin-bottom: 20px;

  thead {
    background: #f8f9fa;
  }

  th {
    padding: 16px;
    text-align: left;
    font-weight: 600;
    color: #555;
    border-bottom: 2px solid #e0e0e0;
    font-size: 14px;
    white-space: nowrap;

    @media (max-width: 768px) {
      padding: 10px;
    }
  }

  td {
    padding: 16px;
    border-bottom: 1px solid #f0f0f0;
    color: #333;
    font-size: 14px;

    @media (max-width: 768px) {
      padding: 10px;
      font-size: 12px;
    }
  }

  tbody tr:hover {
    background: #f8f9fa;
  }
`;

const NoData = styled.td`
  text-align: center;
  color: #999;
  padding: 40px !important;
  font-style: italic;
`;

const StatusBadge = styled.span`
  display: inline-block;
  padding: 6px 12px;
  border-radius: 20px;
  font-size: 12px;
  font-weight: 500;
  background: ${props => {
    if (props.status === 'approved') return '#d4edda';
    if (props.status === 'pending') return '#fff3cd';
    if (props.status === 'rejected') return '#f8d7da';
    return '#e2e3e5';
  }};
  color: ${props => {
    if (props.status === 'approved') return '#155724';
    if (props.status === 'pending') return '#856404';
    if (props.status === 'rejected') return '#721c24';
    return '#383d41';
  }};
`;

const PaymentBadge = styled.span`
  display: inline-block;
  padding: 6px 12px;
  border-radius: 20px;
  font-size: 12px;
  font-weight: 500;
  background: ${props => props.type === 'free_trial' ? '#cce5ff' : '#e2d9f3'};
  color: ${props => props.type === 'free_trial' ? '#004085' : '#4a235a'};
`;

const FirstBadge = styled.span`
  display: inline-block;
  padding: 4px 10px;
  border-radius: 20px;
  font-size: 12px;
  font-weight: 500;
  background: ${props => props.isFirst ? '#d4edda' : '#f8f9fa'};
  color: ${props => props.isFirst ? '#155724' : '#6c757d'};
`;

const TableInfo = styled.div`
  padding-top: 20px;
  border-top: 1px solid #e0e0e0;
  color: #666;
  font-size: 14px;

  strong {
    color: #333;
    font-size: 16px;
  }
`;

function SiteList() {
  const [sites, setSites] = useState([]);
  const [loading, setLoading] = useState(false);
  const [searchTerm, setSearchTerm] = useState('');
  const navigate = useNavigate();

  const token = useSelector((state) => state.auth.token);

  useEffect(() => {
    if (!token) {
      navigate('/login');
    }
  }, [token, navigate]);

  const fetchSites = async () => {
    if (!token) return;

    try {
      setLoading(true);
      // 여기에 추구 고친 api 넣기
      const res = await axios.get(`${process.env.REACT_APP_API_URL}/site/admin`, {
        headers: {
          'access-token': token
        }
      });
      console.log(res.data)
      if (Array.isArray(res.data)) {
        setSites(res.data);
      } else if (res.data?.data && Array.isArray(res.data.data)) {
        setSites(res.data.data);
      } else {
        setSites([]);
      }
    } catch (error) {
      console.error('사이트 리스트 조회 실패:', error);
      if (error?.response?.status === 401) {
        navigate('/login');
      } else {
        alert(error?.response?.data?.detail || '사이트 리스트를 불러오는데 실패했습니다.');
      }
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    if (token) {
      fetchSites();
    }
  }, [token]);

  const formatDate = (dateString) => {
    if (!dateString) return '-';
    const date = new Date(dateString);
    return date.toLocaleDateString('ko-KR', {
      year: 'numeric',
      month: '2-digit',
      day: '2-digit'
    });
  };

  const getStatusText = (status) => {
    if (status === 'approved') return '승인';
    if (status === 'pending') return '대기';
    if (status === 'rejected') return '거부';
    return status || '-';
  };

  const getPaymentTypeText = (type) => {
    if (type === 'free_trial') return '무료 체험';
    if (type === 'paid') return '유료';
    if (type === 'free') return '무료';
    return type || '-';
  };

  const filteredSites = sites.filter(site => {
    const q = searchTerm.toLowerCase();
    if (!q) return true;
    return (
      (site.name && site.name.toLowerCase().includes(q)) ||
      (site.domain && site.domain.toLowerCase().includes(q)) ||
      (site.client_name && site.client_name.toLowerCase().includes(q)) ||
      (site.client_email && site.client_email.toLowerCase().includes(q))
    );
  });

  return (
    <Container>
      <Header>
        <h1>사이트 리스트</h1>
        <Actions>
          <SearchInput
            type="text"
            placeholder="사이트명/도메인/소유자 검색..."
            value={searchTerm}
            onChange={(e) => setSearchTerm(e.target.value)}
          />
          <RefreshButton onClick={fetchSites} disabled={loading}>
            {loading ? '새로고침 중...' : '새로고침'}
          </RefreshButton>
        </Actions>
      </Header>

      <Content>
        <TableContainer>
          <Table>
            <thead>
              <tr>
                <th>사이트명</th>
                <th>도메인</th>
                <th>소유자</th>
                <th>상태</th>
                <th>구독 유형</th>
                <th>익스텐션 수</th>
                <th>첫 구독</th>
                <th>최근 방문</th>
                <th>등록일</th>
              </tr>
            </thead>
            <tbody>
              {filteredSites.length === 0 ? (
                <tr>
                  <NoData colSpan="9">
                    {loading ? '불러오는 중...' : searchTerm ? '검색 결과가 없습니다.' : '사이트 데이터가 없습니다.'}
                  </NoData>
                </tr>
              ) : (
                filteredSites.map((site) => (
                  <tr key={site.id}>
                    <td>{site.name || '-'}</td>
                    <td>{site.domain || '-'}</td>
                    <td>
                      <div style={{ fontWeight: 500 }}>{site.client_name || '-'}</div>
                      <div style={{ fontSize: 12, color: '#6b7280' }}>{site.client_email || ''}</div>
                    </td>
                    <td>
                      <StatusBadge status={site.status}>
                        {getStatusText(site.status)}
                      </StatusBadge>
                    </td>
                    <td>
                      <PaymentBadge type={site.subscribe_payment_type}>
                        {getPaymentTypeText(site.subscribe_payment_type)}
                      </PaymentBadge>
                    </td>
                    <td>{site.extension_count ?? '-'}</td>
                    <td>
                      <FirstBadge isFirst={site.is_first_subscribe}>
                        {site.is_first_subscribe ? '첫 구독' : '재구독'}
                      </FirstBadge>
                    </td>
                    <td>{formatDate(site.visited_at)}</td>
                    <td>{formatDate(site.created_at)}</td>
                  </tr>
                ))
              )}
            </tbody>
          </Table>
        </TableContainer>

        <TableInfo>
          <p>총 사이트 수: <strong>{filteredSites.length}개</strong></p>
        </TableInfo>
      </Content>
    </Container>
  );
}

export default SiteList;
